var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "no-chat-found-container" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "custom-card" }, [
      _c("div", { staticClass: "card" }, [
        _c("p", { staticStyle: { "font-size": "20px" } }, [
          _vm._v(_vm._s(_vm.$t("message.noSystemMessage"))),
        ]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.$t("message.supsisCustomerService")))]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.$t("message.supsisClickExperience")))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "wrap" }, [
        _c(
          "a",
          {
            staticClass: "button",
            attrs: { href: _vm.visitorScreenUrl, target: "_blank" },
          },
          [
            _c("span", [_vm._v(_vm._s(_vm.$t("message.customerPage")))]),
            _vm._v(" "),
            _c("img", {
              staticClass: "message-img",
              attrs: {
                src: "/static/img/message-smile-square-svgrepo-com.svg",
              },
            }),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "live-support-image" }, [
      _c("img", { attrs: { src: "/static/img/liveSupportChat.svg" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }